<template>
    <div :class="[
        'component',
        'component__wrapper',
        overlay ? 'component__wrapper--overlay' : '',
        border ? 'component__wrapper--border' : ''
    ]">
        <slot></slot>
    </div>
</template>

<script>
export default {
  name: 'component-wrapper',
  props: {
    overlay: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: false
    }
  },
  inject: ['$validator']
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/shared/componentwrapper";
</style>
